import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import { Gtm } from '../gtm.event';
import './gtm-event-signup';

@Injectable({
    providedIn: 'root'
})
export class GtmEventSignupTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * Customer model service
     */
    private customerModel = inject(CustomerModel);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Timeout service
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'nexusCustomerRegister') {
                // delay cause we need data to be set
                this.timeoutService.setTimeout(() => {
                    if (this.customerModel.isLoggedIn) {
                        this.dispatch(event, 'account');
                    }
                }, 100);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, signupMethod: Gtm.Event['sign_up']['signup_method']) {
        return this.gtmService.dispatch({
            event: 'sign_up',
            triggerContext: {
                trigger
            },
            signup_method: signupMethod
        });
    }
}
